'use client';

import MainContainer from './_components';

export default function MainPage() {
  return <MainContainer />;
}
